import { PALETTE_VARS } from "@styles/palette-vars";
import { SIDEBAR_WIDTH_EXPANDED } from "@utils/ui-utils";

/** MUI spacing multiplier value for calculating width of sidebar when closed */
const muiSpacingMultiplier = 8;
const commonStyles = {
  backgroundColor: PALETTE_VARS.surfaces.secondary,
  borderRight: "none"
};

/**
 * Mixins to be used for the sidebar when it is open and closed
 * This is copied from the example in MUI drawer page: https://mui.com/material-ui/react-drawer/#mini-variant-drawer
 */

export const SidebarMixins = {
  openedMixin(theme) {
    return {
      ...commonStyles,
      justifyContent: "space-between",
      width: SIDEBAR_WIDTH_EXPANDED,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      overflowX: "hidden"
    };
  },
  closedMixin(theme) {
    return {
      ...commonStyles,
      justifyContent: "space-between",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: "hidden",
      width: `calc(${theme.spacing(muiSpacingMultiplier)} + 1px)`
    };
  }
};